var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container search" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("h2", [
          _vm._v(
            "\n                Claim - " +
              _vm._s(_vm.claim_id) +
              "\n            "
          )
        ]),
        _vm._v(" "),
        _c("a", { staticClass: "link", attrs: { href: "/claims" } }, [
          _vm._v("Back to claims list")
        ])
      ]),
      _vm._v(" "),
      _vm.claim
        ? _c(
            "div",
            { staticClass: "col-md-12 view-claim-details" },
            [
              _vm.claim.status
                ? [
                    _c("strong", [_vm._v("Status")]),
                    _vm._v(" "),
                    _vm.claim.status == 1
                      ? _c("span", { staticClass: "badge badge-warning" }, [
                          _vm._v("Pending")
                        ])
                      : _vm.claim.status == 2
                      ? _c("span", { staticClass: "badge badge-primary" }, [
                          _vm._v("In Process")
                        ])
                      : _vm.claim.status == 3
                      ? _c("span", { staticClass: "badge badge-success" }, [
                          _vm._v("Processed")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("br")
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.claim.user
                ? [
                    _c("strong", [_vm._v("User")]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        attrs: {
                          href: _vm.$laravelRoute(
                            "users.show",
                            _vm.claim.user_id
                          )
                        }
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.claim.user.name) +
                            "\n                "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("br")
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.claim.user && _vm.claim.user.company
                ? [
                    _c("strong", [_vm._v("Company ")]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        attrs: {
                          href: _vm.$laravelRoute(
                            "companies.show",
                            _vm.claim.user.company.id
                          )
                        }
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.claim.user.company.name) +
                            "\n                "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("br")
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.claim.vehicle
                ? [
                    _c("strong", [_vm._v("Vehicle")]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        attrs: {
                          href: _vm.$laravelRoute(
                            "vehicle-stock.show",
                            _vm.claim.vehicle.id
                          )
                        }
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.claim.vehicle.year) +
                            "\n                    " +
                            _vm._s(_vm.claim.vehicle.make) +
                            "\n                    " +
                            _vm._s(_vm.claim.vehicle.model) +
                            "\n                "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("br")
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c("strong", [_vm._v("Claim Number")]),
              _vm._v(" "),
              _c(
                "a",
                {
                  attrs: {
                    href: _vm.$laravelRoute("claims.show", _vm.claim_id)
                  }
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.claim_id) +
                      "\n            "
                  )
                ]
              ),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("strong", [_vm._v("Reason")]),
              _vm._v(" " + _vm._s(_vm.claim.reason) + " "),
              _c("br"),
              _vm._v(" "),
              _c("strong", [_vm._v("Description")]),
              _vm._v(" " + _vm._s(_vm.claim.description) + " "),
              _c("br"),
              _vm._v(" "),
              _c("strong", [_vm._v("Repair Cost")]),
              _vm._v(" " + _vm._s(_vm.claim.repair_cost) + " "),
              _c("br"),
              _vm._v(" "),
              _c("strong", [_vm._v("Files")]),
              _vm._v(" "),
              _vm.claim.files && _vm.claim.files.length
                ? _c(
                    "ul",
                    _vm._l(_vm.claim.files, function(file) {
                      return _c("li", [
                        _c("a", { attrs: { href: file.url } }, [
                          _vm._v(_vm._s(file.name))
                        ])
                      ])
                    }),
                    0
                  )
                : _vm._e()
            ],
            2
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-014f55b2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-014f55b2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Claims/ShowClaim.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-014f55b2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Claims/ShowClaim.vue
// module chunks = 0